<template>
  <div class="topTip">
    <div class="mainText">{{ mainText }}</div>
  </div>
</template>

<script>
export default {
  name: "topTip",
  props: {
    nodeInfo: Object
  },
  computed: {
    mainText() {
      let text = ""
      switch (this.nodeInfo.type) {
        case "ServiceSearchMulti": {
          text =
            "从一个指定工作表的视图中得到符合条件的批量数据（最多不超过100条），供流程中的计算节点批量操作。"
          break
        }
        case "workFlowStart": {
          if (this.nodeInfo.trigger?.type == "START_TYPE_TASK")
            text =
              "该类型工作流用在项目里的任务类型设置中，将此工作流与任务类型绑定后，会在属于该任务类型的任务完成时触发此工作流。"
        }
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.topTip {
  .mainText {
    padding: 21px 16px;
    background: #f5f5f5;
    border-radius: 3px;
    font-size: 14px;
    color: #757575;
  }
}
</style>
